var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultPfp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_419)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#0C0C0C",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 62.0001C60.8485 62.0001 69.6429 53.2057 69.6429 42.3572C69.6429 31.5088 60.8485 22.7144 50 22.7144C39.1516 22.7144 30.3572 31.5088 30.3572 42.3572C30.3572 53.2057 39.1516 62.0001 50 62.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8743 84.59C93.2965 90.2147 88.0143 101.287 77.8866 101.287H22.1138C11.9861 101.287 6.70395 90.2147 15.1261 84.59C25.1056 77.9252 37.0992 74.0396 50.0002 74.0396C62.9012 74.0396 74.8948 77.9252 84.8743 84.59Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPfp);
export default __webpack_public_path__ + "static/media/default-pfp.901b7a8e2c469e49d0ca8a9a148427b3.svg";
export { ForwardRef as ReactComponent };